import React, { Suspense, lazy } from 'react';
import { Routes,Route } from "react-router";
import Home from './markup/pages/Home'
import Login from './markup/pages/Login'
import AddEmployee from './markup/pages/admin/AddEmployee'

//Import the css files
import './assets/css/style.css'
import './assets/css/bootstrap.css'
import './assets/css/responsive.css'
import './assets/css/color.css'
import './assets/css/custom.css'

import Header from './markup/components/Header/Header'
import Footer from './markup/components/Footer/Footer'
import Contact from './markup/pages/Contact'
import PresidentMessage from "./markup/components/PresidentMessage";
import History from './markup/pages/History';
import Team from './markup/components/TeamSection';
import News from './markup/pages/News';
import AboutSection from "./markup/components/AboutSection";
// import BlogDetail from "./markup/pages/BlogDetail";
import VacancyForm from './markup/pages/VacancyForm'
import Postgrad from "./markup/pages/Postgrad";
import Undergrad from "./markup/pages/Undergrad";
import Distance from "./markup/pages/Distance";
import MekanissaPage from "./markup/pages/distance/MekanissaPage";
import Adwa from  "./markup/pages/distance/AdwaPage";
import Assosa from  "./markup/pages/distance/AssosaPage";
import Axum from  "./markup/pages/distance/AxumPage";
import Bahirdar from "./markup/pages/distance/BahirdarPage";
import Bishoftu from "./markup/pages/distance/BishoftuPage";
import Debrebirhan from "./markup/pages/distance/DebrebirhanPage";
import Dessie from "./markup/pages/distance/DessiePage";
import Harar from "./markup/pages/distance/HararPage";
import Hawassa from "./markup/pages/distance/HawassaPage";
import Jigjiga from "./markup/pages/distance/JigjigaPage";
import Jimma from "./markup/pages/distance/JimmaPage";
import Logia from "./markup/pages/distance/LogiaPage";
import Dmekelle from "./markup/pages/distance/DmekellePage";
import Gondar from "./markup/pages/distance/GondarPage";
import Worota from "./markup/pages/distance/WorotaPage";
import Dmeskel from "./markup/pages/distance/DmeskelPage";
import TVET from "./markup/pages/TVET";
import Unauthorized from "./markup/pages/Unauthorized";
import PrivateAuthRoute from "./markup/components/Auth/PrivateAuthRoute";
import AddNews from "./markup/components/Admin/AddNews/NewsForm";
import Mekele from "./markup/pages/campuses/Mekele";
import Mekanisa from "./markup/pages/campuses/Mekanisa";
import Megenagna from "./markup/pages/campuses/Megenagna";
import Kality from "./markup/pages/campuses/Kality";
import Bisheftu from "./markup/pages/campuses/Bisheftu";
import Meskel from "./markup/pages/campuses/Meskel";
import Misrak from "./markup/pages/campuses/Misrak";
import Training from "./markup/pages/Training";
import BlogDetails from './markup/components/BlogDetails';
import Events from "./markup/components/Events"
import VacancyDetails from "./markup/pages/VacancyDetails";
import NewsTable from "./markup/components/Admin/AddNews/ListNewsForm";
import EmployeesList from "./markup/components/Admin/AddEmployeeForm/EmployeesList";
import VisitorDashboard from "./markup/pages/VisitorDashboard"
import UniversityInfo from "./markup/pages/UniversityInfo"
import AllAnouncement from "./markup/pages/AllAnouncement";
import AnnouncementDetail from "./markup/components/AnnouncementDetail"
import AddAnnouncementForm from "./markup/components/Admin/Announcement/AddAnnouncementForm"
import ListAnnouncementForm from "./markup/components/Admin/Announcement/ListAnnouncementForm";
import ScrollToTopButton from "./markup/pages/ScrollToTopButton";
import MissionVision from "./markup/pages/MissionVision";
import PresidentOffice from "./markup/pages/PresidentOffice"
import CentralICT from "./markup/pages/centralICT"
import CentralRegistrar from "./markup/pages/CentralRegistrar"
import AcademicPresidentOffice from "./markup/pages/AcademicPresidentOffice"
import AdminOffice from"./markup/pages/AdminOffice"
import Overview from "./markup/pages/admission/Overview"
import MscAdmission  from "./markup/pages/admission/MscAdmission"
import UndergradAdmission from "./markup/pages/admission/AdmissionCriteria"
import AdmissionCriteria from "./markup/pages/admission/AdmissionCriteria";
import CentralQuality from "./markup/pages/CentralQuality"
import UserUpcomingEvents from "./markup/pages/UserUpcomingEvents"
import AdminAddEvent from "./markup/components/Admin/AdminAddEvent"
import AdminListEvent from "./markup/components/Admin/AdminListEvent"
import MainCampus from "./markup/pages/campuses/MainCampus"
import MScInAccountingAndFinance from "./markup/pages/curriculum/MScInAccountingAndFinance"
import MScComputerScience from "./markup/pages/curriculum/MScComputerScience"
import MBAProgram from "./markup/pages/curriculum/MBAProgram"
import MScProjectManagement from "./markup/pages/curriculum/MScProjectManagement"
import BScAccountingFinance from "./markup/pages/curriculum/BScAccountingFinance"
import BAinBusinessManagement from "./markup/pages/curriculum/BAinBusinessManagement"
import BAinMarketingManagement from "./markup/pages/curriculum/BAinMarketingManagement"
import BScInComputerScience from "./markup/pages/curriculum/BScInComputerScience"
import BAInEDPM from "./markup/pages/curriculum/BAInEDPM"
import BAInEconomics from "./markup/pages/curriculum/BAInEconomics"
import BAInAgriculturalEconomics from "./markup/pages/curriculum/BAInAgriculturalEconomics"
import BAInRuralDevelopment from "./markup/pages/curriculum/BAInRuralDevelopment"


function App() {
  return (
   
    <>

    <Header />
       <Routes>
      
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/president-message" element={<PresidentMessage />} />
      <Route path="/history" element={<History />} />
      <Route path="/team" element={<Team />} />
      <Route path="/news" element={<News />} />
		  
      <Route path="/about" element={<AboutSection />} />
      <Route path="/universityinfo" element={<UniversityInfo />} />
      <Route path="/postgrad" element={<Postgrad />} />
      <Route path="/undergrad" element={<Undergrad />} />
      <Route path="/distance" element={<Distance />} />
	  <Route path="/dmekanissa" element ={<MekanissaPage />}/>
	  <Route path="/mscacfn" element={<MScInAccountingAndFinance/>}/>
	   <Route path="/msccs" element={<MScComputerScience/>}/>
	 <Route path="/mscmba" element={<MBAProgram/>}/>
      <Route path="/mscpm" element={<MScProjectManagement/>}/>
		   <Route path="/bscacfn" element={<BScAccountingFinance/>}/>
		   <Route path="/bscbm" element={<BAinBusinessManagement/>}/>
		   <Route path="/bscmmkt" element={<BAinMarketingManagement/>}/>
			<Route path="/bsccs" element={<BScInComputerScience/>}/>
			<Route path="/bscedpm" element={<BAInEDPM/>}/>
			<Route path="/bsceco" element={<BAInEconomics/>}/>
			<Route path="/bscagri" element={<BAInAgriculturalEconomics/>}/>	
			<Route path="/bscagriext" element={<BAInRuralDevelopment/>}/>		
		  
		  <Route path="/adwa" element ={<Adwa />}/>
		  <Route path="/assosa" element ={<Assosa />}/>  
		  <Route path="/axum" element ={<Axum />}/>  
		  <Route path="/bahirdar" element ={<Bahirdar />}/>	  
		 <Route path="/bishoftu" element ={<Bishoftu />}/>	
		 <Route path="/debrebirhan" element ={<Debrebirhan />}/>
		 <Route path="/dessie" element ={<Dessie />}/>
		 <Route path="/harar" element ={<Harar />}/>	
		<Route path="/hawassa" element ={<Hawassa />}/>
		<Route path="/jigjiga" element ={<Jigjiga />}/>
		<Route path="/jimma" element ={<Jimma />}/>
		<Route path="/logia" element ={<Logia />}/>
		<Route path="/mekelle" element ={<Dmekelle />}/>
		<Route path="/gondar" element ={<Gondar />}/>
		<Route path="/worota" element ={<Worota />}/>
		<Route path="/meskel-square" element ={<Dmeskel />}/>
			
	
			
      <Route path="/tvet" element={<TVET />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/mekele" element={<Mekele/>  } />
      <Route path="/misrak" element={<Misrak/> }/>
      <Route path="/mekanisa" element={<Mekanisa/>  } />
      <Route path="/megenagna" element={<Megenagna/>  } />
      <Route path="/kality" element={<Kality/> } />
      <Route path="/bisheftu" element={<Bisheftu/> } />
      <Route path="/meskel" element={<Meskel/> } />
      <Route path="/mainOlympia" element={<MainCampus/>}/>
      <Route path="/training" element={<Training />} />
      <Route path="/allannouncement" element={<AllAnouncement />} />
      <Route path="/blogdetails" element ={<BlogDetails/>} />
      <Route path="/events" element ={<Events/>} />
	<Route path="/announcement" element={<AnnouncementDetail />} />	  
      <Route path="/vacancy" element ={<VacancyDetails/>} />
      <Route path="/scroll" element ={<ScrollToTopButton/>} />
      <Route path="/mission" element ={<MissionVision/>}/>
      <Route path="/presidentoffice" element ={<PresidentOffice/>}/>
      <Route path="/acdemicPresident" element = {<AcademicPresidentOffice/>}/>
	  <Route path="/centralICT" element ={<CentralICT/>}/>
		<Route path="/centralRegistrar" element ={<CentralRegistrar/>}/>  
      <Route path="/adminoffice" element ={<AdminOffice/>}/>
      <Route path="/overview" element ={<Overview/>}/>
	  <Route path="/mscAdmission" element ={<MscAdmission/>}/> 	  
	  <Route path="/undergradAdmission" elememt ={<UndergradAdmission/>}/>	  
      <Route path="/admissionCriteria" element ={<AdmissionCriteria/>}/>
      <Route path="/centralQuaity" element = {<CentralQuality/>}/>
      <Route path="/userUpcomingEvents" element={<UserUpcomingEvents/>}/>
      <Route path="/admin/add-employee"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <AddEmployee />
            </PrivateAuthRoute>
          } />

          <Route path="/admin/add-news"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <AddNews />
            </PrivateAuthRoute>
          } />

          <Route path="/admin/add-vacancy"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <VacancyForm />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/list-news"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <NewsTable />
            </PrivateAuthRoute>
          } />
   <Route path="/admin/add-events"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <AdminAddEvent />
            </PrivateAuthRoute>
          } />
<Route path="/admin/list-events"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <AdminListEvent />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/employees"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <EmployeesList />
            </PrivateAuthRoute>
          } />
          <Route path="/visitor/dashboard"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <VisitorDashboard />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/add-announcement"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <AddAnnouncementForm />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/list-announcement"
          element={
            <PrivateAuthRoute roles={[1,2,3]}>
              <ListAnnouncementForm />
            </PrivateAuthRoute>
          } />

    </Routes>
    <Footer />
    </>
 
  );
}

export default App;



/*
import React, { Suspense, lazy } from 'react';
import { Routes, Route } from "react-router-dom";
import Header from './markup/components/Header/Header';
import Footer from './markup/components/Footer/Footer';
import './assets/css/style.css';
import './assets/css/bootstrap.css';
import './assets/css/responsive.css';
import './assets/css/color.css';
import './assets/css/custom.css';

// Lazy load pages and components
const Home = lazy(() => import('./markup/pages/Home'));
const Login = lazy(() => import('./markup/pages/Login'));
const Contact = lazy(() => import('./markup/pages/Contact'));
const PresidentMessage = lazy(() => import("./markup/components/PresidentMessage"));
const History = lazy(() => import('./markup/pages/History'));
const Team = lazy(() => import('./markup/components/TeamSection'));
const News = lazy(() => import('./markup/pages/News'));
const AboutSection = lazy(() => import("./markup/components/AboutSection"));
const Postgrad = lazy(() => import("./markup/pages/Postgrad"));
const Undergrad = lazy(() => import("./markup/pages/Undergrad"));
const Distance = lazy(() => import("./markup/pages/Distance"));
const Unauthorized = lazy(() => import("./markup/pages/Unauthorized"));
const PrivateAuthRoute = lazy(() => import("./markup/components/Auth/PrivateAuthRoute"));
const VacancyForm = lazy(() => import('./markup/pages/VacancyForm'));
const AnnouncementDetail = lazy(() => import("./markup/components/AnnouncementDetail"));
const AllAnouncement = lazy(() => import("./markup/pages/AllAnouncement"));
const AddEmployee = lazy(() => import('./markup/pages/admin/AddEmployee'));
const AddNews = lazy(() => import('./markup/components/Admin/AddNews/NewsForm'));
const ScrollToTopButton = lazy(() => import("./markup/pages/ScrollToTopButton"));
const MissionVision = lazy(() => import("./markup/pages/MissionVision"));
const PresidentOffice = lazy(() => import("./markup/pages/PresidentOffice"));
const CentralICT = lazy(() => import("./markup/pages/centralICT"));
const CentralRegistrar = lazy(() => import("./markup/pages/CentralRegistrar"));
const AcademicPresidentOffice = lazy(() => import("./markup/pages/AcademicPresidentOffice"));
const AdminOffice = lazy(() => import("./markup/pages/AdminOffice"));
const Overview = lazy(() => import("./markup/pages/admission/Overview"));
const MscAdmission = lazy(() => import("./markup/pages/admission/MscAdmission"));
const UndergradAdmission = lazy(() => import("./markup/pages/admission/AdmissionCriteria"));
const AdmissionCriteria = lazy(() => import("./markup/pages/admission/AdmissionCriteria"));
const CentralQuality = lazy(() => import("./markup/pages/CentralQuality"));
const UserUpcomingEvents = lazy(() => import("./markup/pages/UserUpcomingEvents"));
const AdminAddEvent = lazy(() => import("./markup/components/Admin/AdminAddEvent"));
const AdminListEvent = lazy(() => import("./markup/components/Admin/AdminListEvent"));
const MainCampus = lazy(() => import("./markup/pages/campuses/MainCampus"));
const MScInAccountingAndFinance = lazy(() => import("./markup/pages/curriculum/MScInAccountingAndFinance"));
const MScComputerScience = lazy(() => import("./markup/pages/curriculum/MScComputerScience"));
const MBAProgram = lazy(() => import("./markup/pages/curriculum/MBAProgram"));
const MScProjectManagement = lazy(() => import("./markup/pages/curriculum/MScProjectManagement"));
const BScAccountingFinance = lazy(() => import("./markup/pages/curriculum/BScAccountingFinance"));
const BAinBusinessManagement = lazy(() => import("./markup/pages/curriculum/BAinBusinessManagement"));
const BAinMarketingManagement = lazy(() => import("./markup/pages/curriculum/BAinMarketingManagement"));
const BScInComputerScience = lazy(() => import("./markup/pages/curriculum/BScInComputerScience"));
const BAInEDPM = lazy(() => import("./markup/pages/curriculum/BAInEDPM"));
const BAInEconomics = lazy(() => import("./markup/pages/curriculum/BAInEconomics"));
const BAInAgriculturalEconomics = lazy(() => import("./markup/pages/curriculum/BAInAgriculturalEconomics"));
const BAInRuralDevelopment = lazy(() => import("./markup/pages/curriculum/BAInRuralDevelopment"));
const MekanissaPage = lazy(() => import("./markup/pages/distance/MekanissaPage"));
const Adwa = lazy(() => import("./markup/pages/distance/AdwaPage"));
const Assosa = lazy(() => import("./markup/pages/distance/AssosaPage"));
const Axum = lazy(() => import("./markup/pages/distance/AxumPage"));
const Bahirdar = lazy(() => import("./markup/pages/distance/BahirdarPage"));
const Bishoftu = lazy(() => import("./markup/pages/distance/BishoftuPage"));
const Debrebirhan = lazy(() => import("./markup/pages/distance/DebrebirhanPage"));
const Dessie = lazy(() => import("./markup/pages/distance/DessiePage"));
const Harar = lazy(() => import("./markup/pages/distance/HararPage"));
const Hawassa = lazy(() => import("./markup/pages/distance/HawassaPage"));
const Jigjiga = lazy(() => import("./markup/pages/distance/JigjigaPage"));
const Jimma = lazy(() => import("./markup/pages/distance/JimmaPage"));
const Logia = lazy(() => import("./markup/pages/distance/LogiaPage"));
const Dmekelle = lazy(() => import("./markup/pages/distance/DmekellePage"));
const Gondar = lazy(() => import("./markup/pages/distance/GondarPage"));
const Worota = lazy(() => import("./markup/pages/distance/WorotaPage"));

function App() {
  return (
    <>
      <Header />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/president-message" element={<PresidentMessage />} />
          <Route path="/history" element={<History />} />
          <Route path="/team" element={<Team />} />
          <Route path="/news" element={<News />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/universityinfo" element={<UniversityInfo />} />
          <Route path="/postgrad" element={<Postgrad />} />
          <Route path="/undergrad" element={<Undergrad />} />
          <Route path="/distance" element={<Distance />} />
          <Route path="/dmekanissa" element={<MekanissaPage />} />
          <Route path="/adwa" element={<Adwa />} />
          <Route path="/assosa" element={<Assosa />} />
          <Route path="/axum" element={<Axum />} />
          <Route path="/bahirdar" element={<Bahirdar />} />
          <Route path="/bishoftu" element={<Bishoftu />} />
          <Route path="/debrebirhan" element={<Debrebirhan />} />
          <Route path="/dessie" element={<Dessie />} />
          <Route path="/harar" element={<Harar />} />
          <Route path="/hawassa" element={<Hawassa />} />
          <Route path="/jigjiga" element={<Jigjiga />} />
          <Route path="/jimma" element={<Jimma />} />
          <Route path="/logia" element={<Logia />} />
          <Route path="/dmekelle" element={<Dmekelle />} />
          <Route path="/gondar" element={<Gondar />} />
          <Route path="/worota" element={<Worota />} />
          <Route path="/tvet" element={<TVET />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/training" element={<Training />} />
          <Route path="/allannouncement" element={<AllAnouncement />} />
          <Route path="/blogdetails" element={<BlogDetails />} />
          <Route path="/events" element={<Events />} />
          <Route path="/announcement" element={<AnnouncementDetail />} />
          <Route path="/vacancy" element={<VacancyDetails />} />
          <Route path="/scroll" element={<ScrollToTopButton />} />
          <Route path="/mission" element={<MissionVision />} />
          <Route path="/presidentoffice" element={<PresidentOffice />} />
          <Route path="/academicPresident" element={<AcademicPresidentOffice />} />
          <Route path="/centralICT" element={<CentralICT />} />
          <Route path="/centralRegistrar" element={<CentralRegistrar />} />
          <Route path="/adminoffice" element={<AdminOffice />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/mscAdmission" element={<MscAdmission />} />
          <Route path="/undergradAdmission" element={<UndergradAdmission />} />
          <Route path="/admissionCriteria" element={<AdmissionCriteria />} />
          <Route path="/centralQuality" element={<CentralQuality />} />
          <Route path="/userUpcomingEvents" element={<UserUpcomingEvents />} />

         
          <Route path="/admin/add-employee" element={
            <PrivateAuthRoute roles={[1, 2, 3]}>
              <AddEmployee />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/add-news" element={
            <PrivateAuthRoute roles={[1, 2, 3]}>
              <AddNews />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/add-vacancy" element={
            <PrivateAuthRoute roles={[1, 2, 3]}>
              <VacancyForm />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/list-news" element={
            <PrivateAuthRoute roles={[1, 2, 3]}>
              <NewsTable />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/add-events" element={
            <PrivateAuthRoute roles={[1, 2, 3]}>
              <AdminAddEvent />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/list-events" element={
            <PrivateAuthRoute roles={[1, 2, 3]}>
              <AdminListEvent />
            </PrivateAuthRoute>
          } />
          <Route path="/admin/employees" element={
            <PrivateAuthRoute roles={[1, 2, 3]}>
              <EmployeesList />
            </PrivateAuthRoute>
          } />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
}

export default App;
*/